<div class="mainProd" id="hp-features">
    <div class="contain">
        <h2 class="bTit text-lg-start">Best Seller</h2>
        <div class="cate-products featured-slider products-slider line-bottom-list" data-display="4,2,2,2"
                    data-nav="on">
            <div class="slider-content slider-ref">
            <ul class="slider-wrapper row">
                <ng-container *ngFor="let item of productBests">
                <li class="col-lg-4 slide" [product]="item" ></li>
                </ng-container>
            </ul>
            </div>
        </div>
    </div>
</div>
